import React from "react";

/**
 * Equipment Table Skeleton Loader
 * Provides skeleton loading state for the equipment table during initial data fetch
 */
export const EquipmentTableSkeleton = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={`skeleton-${index}`}>
          {/* Equipment ID */}
          <td style={{ width: "19.5%", paddingRight: "20px" }}>
            <div
              style={{
                width: "120px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Category */}
          <td style={{ width: "16.4%", paddingRight: "20px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Name */}
          <td style={{ width: "19%", paddingRight: "20px" }}>
            <div
              style={{
                width: "150px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Purchase Date */}
          <td style={{ width: "20.4%", paddingRight: "20px" }}>
            <div
              style={{
                width: "130px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Assigned User */}
          <td style={{ minWidth: "300px", paddingRight: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "50%",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
              <div
                style={{
                  width: "120px",
                  height: "16px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </div>
          </td>
          
          {/* Details Button */}
          <td style={{ paddingRight: "20px" }}>
            <div
              style={{
                width: "70px",
                height: "32px",
                backgroundColor: "#e5e7eb",
                borderRadius: "6px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
        </tr>
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

